import { Routes } from '@angular/router';
import { NotFound } from './not-found/not-found';
import { Home } from './home/home';
import { AuthGuard } from './auth/auth-guard';
import { CognitoGroupGuard } from './auth/cognito-group-guard';
import { NoAccess } from './auth/no-access/no-access';
import { Voice } from './voice/voice';
// import { Chat } from './chat/chat';
import { Shortcuts } from './shortcuts/shortcuts';
import { ChatHistory } from './chat/chat-history/chat-history';
import { Sandbox } from './sandbox/sandbox';

export const routes: Routes = [
    {
        path: '',
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                redirectTo: 'home',
                pathMatch: 'full'
            },
            {
                path: 'home',
                component: Home,
                canActivate: [CognitoGroupGuard],
                children: [
                    {
                        path: '',
                        redirectTo: 'voice',
                        pathMatch: 'full'
                    },
                    {
                        path: 'voice',
                        component: Voice,
                        canActivate: [CognitoGroupGuard],
                    },
                    {
                        path: 'voice/:id',
                        component: Voice,
                        canActivate: [CognitoGroupGuard],
                    },
                    // {
                    //     path: 'chat',
                    //     component: Chat,
                    //     canActivate: [CognitoGroupGuard],
                    // },
                    // {
                    //     path: 'chat/:id',
                    //     component: Chat,
                    //     canActivate: [CognitoGroupGuard],
                    // },
                    {
                        path: 'shortcuts',
                        component: Shortcuts,
                        canActivate: [CognitoGroupGuard],
                    },
                ],
            },
        ],
    },
    {
        path: 'chat-history',
        component: ChatHistory,
        canActivate: [CognitoGroupGuard],
    },
    { path: 'sandbox', component: Sandbox },
    { path: 'no-access', component: NoAccess },
    { path: '**', component: NotFound }
];
